var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-campaign-linkedin';
                    var viewUrl = 'gfx/sprite.svg#view-icon-campaign-linkedin';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 15 15',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };